import { render, staticRenderFns } from "./mentors.vue?vue&type=template&id=691b2874&scoped=true"
import script from "./mentors.vue?vue&type=script&lang=js"
export * from "./mentors.vue?vue&type=script&lang=js"
import style0 from "./mentors.vue?vue&type=style&index=0&id=691b2874&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "691b2874",
  null
  
)

export default component.exports